import React from "react";

export default function FunctionalSkills() {
  const functionalSkillGroups = [
    {
      title: "Capital Markets & Core Domain",
      skills: [
        "Capital Markets",
        "TCS BaNCS",
        "Settlement Process",
        "Cash & Pricing",
        "Trade Lifecycle",
        "Financial Messaging",
        "Banking & Payments Domain",
      ],
    },
    {
      title: "SWIFT MT Messages",
      skills: [
        "SWIFT MT540–MT548",
        "SWIFT MT530",
        "SWIFT MT596",
        "SWIFT MT598",
        "SWIFT MT509",
        "SWIFT MT518",
        "SWIFT MT101",
        "SWIFT MT103",
        "SWIFT MT202",
      ],
    },
    {
      title: "ISO 20022 Messages",
      skills: [
        "sese.030",
        "sese.024",
        "pacs.008",
        "pacs.009",
      ],
    },
  ];

  return (
    <section className="functional-section">
      <div className="left my-4">
        <h1>FUNCTIONAL SKILLS</h1>
      </div>

      <div className="functional-grid">
        {functionalSkillGroups.map((group, index) => (
          <div className="functional-card" key={index}>
            <h3 className="functional-title">{group.title}</h3>

            <div className="functional-chip-wrap">
              {group.skills.map((skill, skillIndex) => (
                <span className="functional-chip" key={skillIndex}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}